import { defineMessages } from "react-intl";

export const commonMessages = defineMessages({
  accept: {
    defaultMessage: "I accept",
  },
  add: {
    defaultMessage: "Add",
  },
  addAddress: {
    defaultMessage: "Add address",
  },
  addressBook: {
    defaultMessage: "Address book",
  },
  allTopics: {
    defaultMessage: "All topics",
  },
  addToCart: {
    defaultMessage: "add to cart",
  },
  cancel: {
    defaultMessage: "Cancel",
  },
  category: {
    defaultMessage: "Category",
  },
  charactersLeft: {
    defaultMessage: "characters left",
  },
  checkout: {
    defaultMessage: "Checkout",
  },
  clearFilterHeader: {
    defaultMessage: "CLEAR FILTERS",
  },
  collection: {
    defaultMessage: "collection",
  },
  collectionCapitalized: {
    defaultMessage: "Collection",
  },
  congratulations: {
    defaultMessage: "Congratulations!",
  },
  contactUs: {
    defaultMessage: "contact us",
  },
  days: {
    defaultMessage: "days",
  },
  delete: {
    defaultMessage: "Delete",
  },
  download: {
    defaultMessage: "Download",
  },
  eMail: {
    defaultMessage: "Email Address",
  },
  editAddress: {
    defaultMessage: "Edit address",
  },
  filterHeader: {
    defaultMessage: "FILTERS",
  },
  firstName: {
    defaultMessage: "First Name",
  },
  free: {
    defaultMessage: "Free",
  },
  from: {
    defaultMessage: "from",
  },
  itemsMinMax: {
    defaultMessage:
      "Please, choose between {minItems} and {maxItems} items to continue",
  },
  itemsSelected: {
    defaultMessage: "{selectedNumber} items selected",
  },
  lastName: {
    defaultMessage: "Last Name",
  },
  less: {
    defaultMessage: "Less",
  },
  loading: {
    defaultMessage: "Loading",
  },
  loadMore: {
    defaultMessage: "Load more",
  },
  logOut: {
    defaultMessage: "Log Out",
  },
  lowStock: {
    defaultMessage: "Low stock",
  },
  maxQtyIs: {
    defaultMessage: "Maximum quantity is {maxQuantity}",
  },
  more: {
    defaultMessage: "More",
  },
  myAccount: {
    defaultMessage: "My Account",
  },
  noItemsAvailable: {
    defaultMessage: "No items available",
  },
  orderHistory: {
    defaultMessage: "Order history",
  },
  outOfStock: {
    defaultMessage: "Out of stock",
  },
  password: {
    defaultMessage: "Password",
  },
  phone: {
    defaultMessage: "Phone",
  },
  phoneNumber: {
    defaultMessage: "Phone number: {phone}",
  },
  price: {
    defaultMessage: "Price",
  },
  priceRange: {
    defaultMessage: "Price range",
  },
  products: {
    defaultMessage: "Products",
  },
  promoCode: {
    defaultMessage: "Promo code",
  },
  quantity: {
    defaultMessage: "Quantity",
  },
  readOn: {
    defaultMessage: "Read on",
  },
  ReadMore: {
    defaultMessage: "Read more",
  },
  register: {
    defaultMessage: "Register",
  },
  reviewCount: {
    defaultMessage: "based on {count} reviews",
  },
  save: {
    defaultMessage: "Save",
  },
  saveProject: {
    defaultMessage: "Save project",
  },
  search: {
    defaultMessage: "search",
  },
  seeAllArticles: {
    defaultMessage: "See all articles",
  },
  SeeAndFeelTheDifference: {
    defaultMessage: "See and feel the difference",
  },
  send: {
    defaultMessage: "Send",
  },
  shipping: {
    defaultMessage: "Shipping",
  },
  shortEmail: {
    defaultMessage: "Email",
  },
  showEmail: {
    defaultMessage: "Email: {email}",
  },
  showMore: {
    defaultMessage: "Show more",
  },
  signIn: {
    defaultMessage: "Sign in",
  },
  sku: {
    defaultMessage: "SKU",
  },
  smallEmail: {
    defaultMessage: "email",
  },
  status: {
    defaultMessage: "Status",
  },
  subject: {
    defaultMessage: "Subject",
  },
  subtotal: {
    defaultMessage: "Subtotal",
  },
  success: {
    defaultMessage: "Success!",
  },
  termsOfService: {
    defaultMessage: "Terms of Service",
  },
  to: {
    defaultMessage: "to",
  },
  total: {
    defaultMessage: "Total",
  },
  totalPrice: {
    defaultMessage: "Total Price:",
  },
  variant: {
    defaultMessage: "Variant",
  },
  view: {
    defaultMessage: "View",
  },
  viewAllPhotos: {
    defaultMessage: "View all photos",
  },
  weeks: {
    defaultMessage: "weeks",
  },
  youMayAlsoLike: {
    defaultMessage: "You may also like",
  },
  yourEmailAddress: {
    defaultMessage: "Your email address",
  },
  yourMessage: {
    defaultMessage: "Your message...",
  },
});

export const checkoutMessages = defineMessages({
  addNewAddress: {
    defaultMessage: "Add new address",
  },
  addressNextActionName: {
    defaultMessage: "Continue to Shipping",
  },
  billingAddress: {
    defaultMessage: "BILLING ADDRESS",
  },
  continueShopping: {
    defaultMessage: "CONTINUE SHOPPING",
  },
  paymentMethod: {
    defaultMessage: "PAYMENT METHOD",
  },
  paymentNextActionName: {
    defaultMessage: "Continue to Review",
  },
  reviewNextActionName: {
    defaultMessage: "Place order",
  },
  reviewOrder: {
    defaultMessage: "REVIEW ORDER",
  },
  shippingAddress: {
    defaultMessage: "Shipping Address",
  },
  shippingMethod: {
    defaultMessage: "SHIPPING METHOD",
  },
  shippingNextActionName: {
    defaultMessage: "Continue to Payment",
  },
  stepNameAddress: {
    defaultMessage: "Address",
  },
  stepNamePayment: {
    defaultMessage: "Payment",
  },
  stepNameReview: {
    defaultMessage: "Review",
  },
  stepNameShipping: {
    defaultMessage: "Shipping",
  },
});

export const prodListHeaderCommonMsg = defineMessages({
  sortOptionsClear: {
    defaultMessage: "Clear...",
  },
  sortOptionsName: {
    defaultMessage: "Name Increasing",
  },
  sortOptionsNameDsc: {
    defaultMessage: "Name Decreasing",
  },
  sortOptionsPrice: {
    defaultMessage: "Price Low-High",
  },
  sortOptionsPriceDsc: {
    defaultMessage: "Price High-Low",
  },
  sortOptionsUpdatedAt: {
    defaultMessage: "Last updated Ascending",
  },
  sortOptionsUpdatedAtDsc: {
    defaultMessage: "Last updated Descending",
  },
});

export const validationCommonMsg = defineMessages({
  confirmPassword: {
    defaultMessage: "Passwords do not match",
  },
  passwordRetype: {
    defaultMessage: "Please retype password",
  },
  passwordRetypeMatch: {
    defaultMessage: "Retyped password does not match",
  },
  passwordShort: {
    defaultMessage: "Password is to short!",
  },
  required: {
    defaultMessage: "Required field",
  },
});

export const errorCommonMsg = defineMessages({
  choose_payment: {
    defaultMessage: "Please choose payment method.",
  },
  provide_billing_address: {
    defaultMessage: "Please provide billing address.",
  },
  provide_email_address: {
    defaultMessage: "Please provide email address.",
  },
  provide_shipping_address: {
    defaultMessage: "Please provide shipping address.",
  },
});

export const realizationMsg = defineMessages({
  clear_filter: {
    defaultMessage: "Clear filter",
  },
  category: {
    defaultMessage: "Style",
  },
  colors: {
    defaultMessage: "Colors",
  },
  tags: {
    defaultMessage: "Room",
  },
  width: {
    defaultMessage: "Width",
  },
});
